define('frontend-common-components/objectStorageConfig/js/helpers/addStorageTemplateHelper',[
    './awsHelper',
    'i18n!../../nls/objectStorageConfig'
], function (awsHelper, messageBundle) {
    'use strict';

    return function (awsAccountId, externalId) {
        return {
            roleArnPlaceholder: function () {
                return awsHelper.getRoleARN() + messageBundle.storage.signiantFlightRole;
            },

            signiantAccountId: function () {
                return awsAccountId;
            },

            accountId: function () {
                return externalId;
            }
        };
    };
});

